export const IdentitySource = {
  Anon: 'anon',
  Discord: 'discord',
} as const;
export type IdentitySource = (typeof IdentitySource)[keyof typeof IdentitySource];
